import React from 'react';
import useFeatureToggleService from 'feature-toggle';
import { PasswordLayoutProps } from '../Password';
import useUiTheme from '../../../uiTheme';
import ShadcnPasswordLayout from './ShadcnPasswordLayout';

function LegacyPasswordLayout(props: PasswordLayoutProps) {
  const uiTheme = useUiTheme();

  return (
    <uiTheme.forms.BaseInputLayout
      label={props.label}
      name={props.name}
      errors={props.errors}
      showLabel={props.showLabel}
      className={props.className}
      hideLabel={props.hideLabel}
      hint={props.hint}
    >
      <input
        disabled={props.isDisabled}
        name={props.name}
        autoComplete="new-password"
        placeholder={props.placeholder}
        type="password"
        value={props.value || ''}
        onChange={props.onChangeCallback}
        onFocus={props.onFocusCallback}
        onBlur={props.onBlurCallback}
        data-lpignore="true"
      />
    </uiTheme.forms.BaseInputLayout>
  );
}

export default function PasswordLayout(props: PasswordLayoutProps) {
  const { isShadcnUiEnabled } = useFeatureToggleService();

  if (isShadcnUiEnabled()) {
    return <ShadcnPasswordLayout {...props} />;
  } else {
    return <LegacyPasswordLayout {...props} />;
  }
}
